<div class="padded-content bottom-border">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="formrow">
      <label>Vorname</label>
      <input type="text" formControlName="firstName" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['firstName'].errors }" />
      @if (submitted && f['firstName'].errors) {
        <div class="invalid-feedback">
          @if (f['firstName'].errors['required']) {
            <div>Der Vorname ist Pflicht</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Nachname</label>
      <input type="text" formControlName="lastName" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['lastName'].errors }" />
      @if (submitted && f['lastName'].errors) {
        <div class="invalid-feedback">
          @if (f['lastName'].errors['required']) {
            <div>Der Nachname ist Pflicht</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Email</label>
      <input type="email" formControlName="email" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" />
      @if (submitted && f['email'].errors) {
        <div class="invalid-feedback">
          @if (f['email'].errors['required']) {
            <div>Die Email ist Pflicht</div>
          }
          @if (f['email'].errors['email']) {
            <div>Die Email ist nicht korrekt</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Benutzername</label>
      <input type="text" formControlName="username" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['username'].errors }" />
      @if (submitted && f['username'].errors) {
        <div class="invalid-feedback">
          @if (f['username'].errors['required']) {
            <div>Die Email ist Pflicht</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Passwort</label>
      <input type="password" formControlName="password" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
      @if (submitted && f['password'].errors) {
        <div class="invalid-feedback">
          @if (f['password'].errors['required']) {
            <div>Passwort ist Pflicht</div>
          }
          @if (f['password'].errors['minlength']) {
            <div>Dein Passwort muss mindestens 6 Zeichen haben</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Adresse</label>
      <input type="text" formControlName="address" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['address'].errors }" />
      @if (submitted && f['address'].errors) {
        <div class="invalid-feedback">
          @if (f['address'].errors['required']) {
            <div>Adresse ist Pflicht</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>PLZ</label>
      <input type="text" formControlName="zip" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['zip'].errors }" />
      @if (submitted && f['zip'].errors) {
        <div class="invalid-feedback">
          @if (f['zip'].errors['required']) {
            <div>PLZ ist Pflicht</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Ort</label>
      <input type="text" formControlName="city" class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f['city'].errors }" />
      @if (submitted && f['city'].errors) {
        <div class="invalid-feedback">
          @if (f['city'].errors['required']) {
            <div>Ort ist Pflicht</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <label>Mobile</label>
      <ngx-intl-tel-input [onlyCountries]="mobileAvailableCountries"
        [selectedCountryISO]="switzerland"
        [ngClass]="{ 'is-invalid': submitted && f['mobile'].errors }"
        [cssClass]="(submitted && f['mobile'].errors) ? 'form-control is-invalid' : 'form-control'"
      [phoneValidation]="true" [inputId]="'mobile'" name="mobile" formControlName="mobile"></ngx-intl-tel-input>
      @if (submitted && f['mobile'].errors) {
        <div class="invalid-feedback">
          @if (f['mobile'].errors['required']) {
            <div>Deine Mobilenummer ist Pflicht</div>
          }
          @if (f['mobile'].errors['validatePhoneNumber']) {
            <div>Die Mobilenummer ist ungültig</div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <div class="gtc-checkbox">
        <input type="checkbox" formControlName="gtcAccepted" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f['gtcAccepted'].errors }" />
        <span>Ich akzeptiere die <a class="legal-link" routerLink="/agb" target="_blank">ALLGEMEINEN BESTIMMUNGEN</a>
        und die <a class="legal-link" routerLink="/datenschutz" target="_blank">DATENSCHUTZERKLÄRUNG</a>.</span>
      </div>
      @if (submitted && f['gtcAccepted'].errors) {
        <div class="invalid-feedback">
          @if (f['gtcAccepted'].errors['required']) {
            <div>Bitte lies die Regeln und erkläre Dich damit einverstanden.
            </div>
          }
        </div>
      }
    </div>
    <div class="formrow">
      <button>REGISTRIEREN</button>
    </div>
    <div class="formrow">
      <a routerLink="/login">ZURÜCK ZUM LOGIN?</a>
    </div>
  </form>
</div>